import styled from "styled-components";
import { fadeIn } from "../Common/CommonStyles";

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const ModalContainer = styled.div`
  width: auto;
  height: auto;
  max-width: 2000px;
  background-color: #fff;
  border-radius: 5px;
  padding: 1rem;
  text-align: center;
  position: relative;

  @media screen and (min-width: 844px) {
    width: 70%;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background-color: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
`;